const voiceText = {
  // cancelLeaveSuccess: '销假成功',
  oldPeopleComeBackByLeave: '销假成功  销假人',
  oldPeopleComeBackByLeaveIsRepeat: '你已销假',
  oldPeopleComeBackByFreedom: '欢迎回归',
  haveOutRecord: '你已登记',
  outRecordSwipeCardSuccess: '登记成功',
  outRecordSwipeCardFair: '登记失败',
  swipeCardFair: '刷卡失败',

}
export default voiceText



// WEBPACK FOOTER //
// ./src/config/voiceText.js